var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailMarketing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.845 4.447 5.18 28.487c-1.844 1.21-1.455 3.961.655 4.638L42.5 44.878c1.725.553 3.5-.702 3.5-2.475V6.61c0-2.084-2.383-3.324-4.155-2.162Z",
    fill: "#2EBCFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44.671 4.348-18.15 35.408 17.73 5.684c.862.276 1.75-.351 1.75-1.238L46 6.281s-.12-.688-.469-1.175c-.318-.445-.86-.758-.86-.758Z",
    fill: "#985184"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.885 35.634 44.67 4.342 23.322 46l-9.437-10.366Z",
    fill: "#144496"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailMarketing);
export default __webpack_public_path__ + "static/media/Email Marketing.ab00d81e9fabb423b19686c4d7364fdd.svg";
export { ForwardRef as ReactComponent };